namespace Areas.ITJob {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("ITJob", ["Active", "Inactive"], "List");

    export function tabInitialized(params: any) {
    return Areas.tabInitialized(tabItems)(params);
    }

}